import { MeetingWidgetContext } from 'presentations/reducers/MeetingWidget';
import { memo, useContext, useCallback, useEffect, useState } from 'react';
import VideoUserList from 'presentations/views/components/organisms/VideoUserList';
import VideoLocalUser from 'presentations/views/components/organisms/VideoLocalUser';
import { formatClientEventName, UserMouseEvent } from './hooks/pusher';

interface Props {}
let sendMouseEvent: UserMouseEvent | null;

const Component = memo((props: Props) => {
  const { state } = useContext(MeetingWidgetContext);
  const [mouseX, setMouseX] = useState(0);
  const [mouseY, setMouseY] = useState(0);

  const onMouseMove = useCallback(
    (e: any) => {
      if (!state.channel) return;
      if (!state.liveViewer) return;
      // if (!state.isShowCall) return;
      if (!state.isShowIcon) return;

      // local
      setMouseX(e.pageX || e.clientX);
      setMouseY(e.pageY || e.clientY);

      // send network
      sendMouseEvent = {
        userId: state.liveViewer.uid,
        x: mouseX,
        y: mouseY,
      };
    },
    [state.channel, state.liveViewer, state.isShowIcon, mouseX, mouseY],
  );

  useEffect(() => {
    const timer = setInterval(() => {
      if (!sendMouseEvent) return;
      if (!state.channel) return;
      if (!state.viewer) return;
      const eventName = formatClientEventName(state.viewer.team!.uid, 'moved');
      if (eventName) {
        state.channel.trigger(eventName, sendMouseEvent);
      }
      sendMouseEvent = null;
    }, 600);
    return function cleanUp() {
      clearInterval(timer);
    };
  }, [state.channel, state.viewer]);

  useEffect(() => {
    window.addEventListener('mousemove', onMouseMove);
    return () => window.removeEventListener('mousemove', onMouseMove);
  }, [onMouseMove]);

  if (!state.liveViewer) return null;
  // if (!state.isShowCall) return null;

  return (
    <>
      <VideoLocalUser
        isShowIcon={state.isShowIcon}
        localUser={state.liveViewer}
        mouseX={mouseX}
        mouseY={mouseY}
      />
      <VideoUserList
        isShowIcon={state.isShowIcon}
        localUserId={state.liveViewer.uid}
        localPageId={state.liveViewer.pageId}
        liveUsers={state.liveUsers}
      />
    </>
  );
});
export default Component;
